import register from 'preact-custom-element';
import { VidstackPlayer, Props as VidstackProps } from '@course/components/vidstack-player';

export type Props = VidstackProps;
export const tagName = 'vidstack-card';

function Wrapper(
  props: Omit<Props, 'autoplay'> & {
    hascaptions?: string;
    hidecaptions?: string;
    captionsurl?: string;
    autoplay?: string;
  },
) {
  return (
    <VidstackPlayer
      {...props}
      // Re-assign the HTML attribute to the correct prop name
      hasCaptions={props.hascaptions === 'true'}
      captionsURL={props.captionsurl}
      hideCaptions={props.hidecaptions === 'true'}
      // Custom-element attributes arrive as strings, so coerce to a boolean.
      autoplay={props.autoplay === 'true'}
    />
  );
}

register(
  Wrapper,
  tagName,
  [
    'url',
    'poster',
    'hascaptions',
    'captionsurl',
    'downloadUrl',
    'type',
    'load',
    'overlay',
    'ratio',
    'hidecaptions',
    'autoplay',
  ],
  {
    shadow: false,
  },
);
